import { Tag, Typography, Space } from "antd";

const { Text } = Typography;
const columns = [
    {
        title: "تاریخ ثبت",
        dataIndex: "createdAt",
        key: "createdAt",
        width: 110,
        sorter: true,
    },
    {
        title: "اخرین ویرایش",
        dataIndex: "updatedAt",
        key: "updatedAt",
        width: 130,
        sorter: true,
    },
    {
        title: "عنوان",
        dataIndex: "title",
        key: "title",
        width: 180,
        sorter: true,
        ellipsis: true,
    },
    {
        title: "تاریخ انقضا",
        dataIndex: "expiresAt",
        key: "expiresAt",
        width: 130,
        sorter: true,
    },
    {
        title: "پیام",
        dataIndex: "body",
        key: "body",
        ellipsis: true,
    },
    {
        title: "جزییات",
        dataIndex: "details",
        key: "details",
        width: 100,
    },
];

export default columns;
